import { roundNumber } from "@common/utils/roundNumber";

export const yTicksCallback = (value: number | string) => {
  const unit = Number(value);

  if (Number.isInteger(unit)) return unit;

  return roundNumber(unit);
};
